import { OnChanges, OnDestroy, OnInit, SimpleChanges, } from '@angular/core';
import { FormBuilder, FormControl, Validators, } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { NugetType, } from '@models';
import { DeploymentAuthenticationType } from '@services';
import UiValidators, { UI_PASSWORD_MAX_LENGTH, UI_URL_MAX_LENGTH, UI_USERNAME_MAX_LENGTH, } from '@validators';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject, Subject, } from 'rxjs';
import { delay, distinctUntilChanged, filter, takeUntil, tap, } from 'rxjs/operators';
export var DeploymentGeneralSettingsControl;
(function (DeploymentGeneralSettingsControl) {
    DeploymentGeneralSettingsControl["useSharedFeed"] = "useSharedFeed";
    DeploymentGeneralSettingsControl["allowTenantPublish"] = "allowTenantPublish";
    DeploymentGeneralSettingsControl["isInternalDeployment"] = "isInternalDeployment";
    DeploymentGeneralSettingsControl["externalDeploymentUrl"] = "externalDeploymentUrl";
    DeploymentGeneralSettingsControl["selectedAuthenticationType"] = "selectedAuthenticationType";
    DeploymentGeneralSettingsControl["authenticationTypes"] = "authenticationTypes";
})(DeploymentGeneralSettingsControl || (DeploymentGeneralSettingsControl = {}));
export var DeploymentAuthenticationTypeControl;
(function (DeploymentAuthenticationTypeControl) {
    DeploymentAuthenticationTypeControl["apiKey"] = "apiKey";
    DeploymentAuthenticationTypeControl["basicAuthUsername"] = "basicAuthUsername";
    DeploymentAuthenticationTypeControl["basicAuthPassword"] = "basicAuthPassword";
    DeploymentAuthenticationTypeControl["secure"] = "secure";
})(DeploymentAuthenticationTypeControl || (DeploymentAuthenticationTypeControl = {}));
var UiNugetDeploymentSettingsComponent = /** @class */ (function () {
    function UiNugetDeploymentSettingsComponent(_fb, _appState) {
        var _this = this;
        this._fb = _fb;
        this._appState = _appState;
        this.DeploymentAuthenticationType = DeploymentAuthenticationType;
        this.DeploymentGeneralSettingsControl = DeploymentGeneralSettingsControl;
        this.DeploymentAuthenticationTypeControl = DeploymentAuthenticationTypeControl;
        this._destroyed$ = new Subject();
        this._isInitialized = false;
        this._authenticationTypeValidator = function (form) {
            var validAuthenticationTypes = _this._getAuthenticationTypes(_this.nugetType, _this.deploymentTypeChanges$.value);
            var selectedAuthenticationType = form.get(DeploymentGeneralSettingsControl.selectedAuthenticationType).value;
            if (validAuthenticationTypes.includes(selectedAuthenticationType)) {
                return null;
            }
            return {
                invalidSelection: true,
            };
        };
        this.formGroup = this._fb.group({});
    }
    Object.defineProperty(UiNugetDeploymentSettingsComponent.prototype, "isInitialized", {
        get: function () {
            return this._isInitialized;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiNugetDeploymentSettingsComponent.prototype, "authenticationTypesFormGroup", {
        get: function () {
            return this.formGroup.get(DeploymentGeneralSettingsControl.authenticationTypes);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiNugetDeploymentSettingsComponent.prototype, "authenticationTypeFormGroupNames", {
        get: function () {
            return Object.keys(this.authenticationTypesFormGroup.controls);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiNugetDeploymentSettingsComponent.prototype, "authenticationTypeFormGroupNamesOrdered", {
        get: function () {
            return this._getAuthenticationTypes(this.nugetType, this.deploymentTypeChanges$.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiNugetDeploymentSettingsComponent.prototype, "showTenantPublishOptions", {
        get: function () {
            return this._appState.user.loggedInAsHost &&
                this.nugetType === NugetType.Libraries;
        },
        enumerable: true,
        configurable: true
    });
    UiNugetDeploymentSettingsComponent.prototype.getAuthenticationTypeFormGroupByName = function (name) {
        return this.authenticationTypesFormGroup.get(name);
    };
    Object.defineProperty(UiNugetDeploymentSettingsComponent.prototype, "hasMultipleFeedSources", {
        get: function () {
            return this._appState.user.loggedInAsHost ?
                false :
                this._originalDeploymentSettings.useSharedFeed != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiNugetDeploymentSettingsComponent.prototype, "_isSingleAuthenticationType", {
        get: function () {
            return this.authenticationTypeFormGroupNames.length === 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiNugetDeploymentSettingsComponent.prototype, "_initialDeploymentType", {
        get: function () {
            return this._originalDeploymentSettings.isInternalDeployment ? 'internal' : 'external';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiNugetDeploymentSettingsComponent.prototype, "_initialFeedSource", {
        get: function () {
            return this.hasMultipleFeedSources && this._originalDeploymentSettings.useSharedFeed ? 'host' : 'tenant';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiNugetDeploymentSettingsComponent.prototype, "_initialSelectedAuthenticationType", {
        get: function () {
            return this._originalDeploymentSettings.selectedAuthenticationType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiNugetDeploymentSettingsComponent.prototype, "_showDeploymentUrlField", {
        set: function (isExternalDeployment) {
            if (isExternalDeployment) {
                this.formGroup.addControl(DeploymentGeneralSettingsControl.externalDeploymentUrl, new FormControl(this._originalDeploymentSettings.externalDeploymentUrl, Validators.compose([
                    Validators.required,
                    UiValidators.httpUrl(true),
                    Validators.maxLength(UI_URL_MAX_LENGTH),
                ])));
            }
            else {
                this.formGroup.removeControl(DeploymentGeneralSettingsControl.externalDeploymentUrl);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiNugetDeploymentSettingsComponent.prototype, "_enableAuthenticationTypeFormGroup", {
        set: function (selectedAuthenticationType) {
            var _this = this;
            this.authenticationTypeFormGroupNames.forEach(function (authenticationTypeFormGroupName) {
                var authenticationTypeFormGroup = _this.getAuthenticationTypeFormGroupByName(authenticationTypeFormGroupName);
                if (authenticationTypeFormGroupName === selectedAuthenticationType) {
                    authenticationTypeFormGroup.enable();
                }
                else {
                    _this._resetAuthenticationTypeFormGroupControls(authenticationTypeFormGroup);
                    authenticationTypeFormGroup.disable();
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiNugetDeploymentSettingsComponent.prototype, "_authenticationTypeFormGroups", {
        set: function (deploymentType) {
            this._showDeploymentUrlField = deploymentType === 'external';
            var authenticationTypes = this._getAuthenticationTypes(this.nugetType, deploymentType);
            this._removeUnavailableAuthenticationTypeFormGroups(authenticationTypes);
            this._addMissingAuthenticationTypeFormGroups(authenticationTypes);
            if (this._isSingleAuthenticationType) {
                var onlyAuthenticationType = authenticationTypes[0];
                this.formGroup.get(DeploymentGeneralSettingsControl.selectedAuthenticationType).setValue(onlyAuthenticationType);
            }
            this._enableAuthenticationTypeFormGroup = this.formGroup.get(DeploymentGeneralSettingsControl.selectedAuthenticationType).value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiNugetDeploymentSettingsComponent.prototype, "_showDeploymentGeneralSettings", {
        set: function (feedSource) {
            var _this = this;
            if (feedSource === 'tenant') {
                this.formGroup.addControl(DeploymentGeneralSettingsControl.isInternalDeployment, new FormControl(this._originalDeploymentSettings.isInternalDeployment));
                this.formGroup.addControl(DeploymentGeneralSettingsControl.selectedAuthenticationType, new FormControl(this._originalDeploymentSettings.selectedAuthenticationType));
                this.formGroup.addControl(DeploymentGeneralSettingsControl.authenticationTypes, this._fb.group({}));
                this.formGroup.setValidators(this._authenticationTypeValidator);
            }
            else {
                this.formGroup.setValidators(null);
                [
                    DeploymentGeneralSettingsControl.isInternalDeployment,
                    DeploymentGeneralSettingsControl.externalDeploymentUrl,
                    DeploymentGeneralSettingsControl.selectedAuthenticationType,
                    DeploymentGeneralSettingsControl.authenticationTypes,
                ].forEach(function (controlName) {
                    return _this.formGroup.removeControl(controlName);
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    UiNugetDeploymentSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.hasMultipleFeedSources) {
            this.formGroup.addControl(DeploymentGeneralSettingsControl.useSharedFeed, new FormControl(this._originalDeploymentSettings.useSharedFeed));
        }
        if (this.showTenantPublishOptions) {
            this.formGroup.addControl(DeploymentGeneralSettingsControl.allowTenantPublish, new FormControl(this._originalDeploymentSettings.allowTenantPublish));
        }
        this.feedSourceChanges$ = new BehaviorSubject(this._initialFeedSource);
        this.deploymentTypeChanges$ = new BehaviorSubject(this._initialDeploymentType);
        this.authenticationTypeChanges$ = new BehaviorSubject(this._initialSelectedAuthenticationType);
        this.feedSourceChanges$
            .pipe(takeUntil(this._destroyed$)).subscribe(function (feedSource) { return _this._onFeedSourceChange(feedSource); });
        this.deploymentTypeChanges$
            .pipe(filter(function () { return _this.feedSourceChanges$.value !== 'host'; }), takeUntil(this._destroyed$)).subscribe(function (deploymentType) { return _this._authenticationTypeFormGroups = deploymentType; });
        this.authenticationTypeChanges$
            .pipe(
        // https://github.com/angular/angular/issues/22556 - if the form is disabled during init, it remains enabled
        // TODO: remove the workaround when the issue gets fixed
        delay(0), 
        // need the _isInitialized variable because the authentication type forms are disabled with a delay(0),
        // so they remain invalid until then, which causes a flash with the invalid warning triangle
        // in the Deployment tab at load time
        tap(function () { return _this._isInitialized = true; }), filter(function () { return _this.feedSourceChanges$.value !== 'host'; }), takeUntil(this._destroyed$)).subscribe(function (authenticationType) { return _this._enableAuthenticationTypeFormGroup = authenticationType; });
        this.formChanges$ =
            this.formGroup.valueChanges
                .pipe(distinctUntilChanged(), takeUntil(this._destroyed$));
    };
    UiNugetDeploymentSettingsComponent.prototype.ngOnChanges = function (changes) {
        if (changes['deploymentSettings']) {
            this._originalDeploymentSettings = cloneDeep(this.deploymentSettings);
        }
    };
    UiNugetDeploymentSettingsComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
    };
    UiNugetDeploymentSettingsComponent.prototype.onFeedSourceRadioChange = function (event) {
        this.feedSourceChanges$.next(event.value ? 'host' : 'tenant');
    };
    UiNugetDeploymentSettingsComponent.prototype.onDeploymentTypeRadioChange = function (event) {
        this.deploymentTypeChanges$.next(event.value ? 'internal' : 'external');
    };
    UiNugetDeploymentSettingsComponent.prototype.onAuthenticationTypeRadioChange = function (event) {
        if (event.value) {
            this.authenticationTypeChanges$.next(event.value);
        }
    };
    UiNugetDeploymentSettingsComponent.prototype._onFeedSourceChange = function (feedSource) {
        this._showDeploymentGeneralSettings = feedSource;
        if (feedSource === 'tenant') {
            this._authenticationTypeFormGroups = this._initialDeploymentType;
        }
    };
    UiNugetDeploymentSettingsComponent.prototype._resetAuthenticationTypeFormGroupControls = function (authenticationTypeFormGroup) {
        var _this = this;
        Object.keys(authenticationTypeFormGroup.controls).forEach(function (controlName) {
            authenticationTypeFormGroup
                .get(controlName)
                .setValue(_this._originalDeploymentSettings[controlName]);
        });
    };
    UiNugetDeploymentSettingsComponent.prototype._removeUnavailableAuthenticationTypeFormGroups = function (authenticationTypes) {
        var _this = this;
        this.authenticationTypeFormGroupNames
            .filter(function (authenticationTypeFormGroupName) {
            return !authenticationTypes.includes(authenticationTypeFormGroupName);
        }).forEach(function (authenticationTypeFormGroupName) {
            var authenticationTypeFormGroup = _this.getAuthenticationTypeFormGroupByName(authenticationTypeFormGroupName);
            _this._resetAuthenticationTypeFormGroupControls(authenticationTypeFormGroup);
            _this.authenticationTypesFormGroup.removeControl(authenticationTypeFormGroupName);
        });
    };
    UiNugetDeploymentSettingsComponent.prototype._addMissingAuthenticationTypeFormGroups = function (authenticationTypes) {
        var _this = this;
        authenticationTypes
            .filter(function (authenticationType) {
            return !_this.authenticationTypeFormGroupNames.includes(authenticationType);
        })
            .forEach(function (authenticationType) {
            var formGroup = _this._getAuthenticationTypeFormGroup(authenticationType);
            _this.authenticationTypesFormGroup.addControl(authenticationType, formGroup);
        });
    };
    UiNugetDeploymentSettingsComponent.prototype._getAuthenticationTypes = function (nugetType, deploymentType) {
        switch (nugetType) {
            case NugetType.Packages:
                return deploymentType === 'internal' ?
                    [
                        DeploymentAuthenticationType.secure,
                        DeploymentAuthenticationType.apiKey,
                    ] : [
                    DeploymentAuthenticationType.apiKey,
                    DeploymentAuthenticationType.basicAuth,
                ];
            case NugetType.Libraries:
                return deploymentType === 'internal' ?
                    [
                        DeploymentAuthenticationType.secure,
                        DeploymentAuthenticationType.apiKey,
                    ] : [
                    DeploymentAuthenticationType.apiKey,
                ];
        }
    };
    UiNugetDeploymentSettingsComponent.prototype._getAuthenticationTypeFormGroup = function (authenticationType) {
        var _a, _b;
        switch (authenticationType) {
            case DeploymentAuthenticationType.apiKey:
                return this._fb.group((_a = {},
                    _a[DeploymentAuthenticationTypeControl.apiKey] = [
                        this._originalDeploymentSettings.apiKey,
                        Validators.compose([
                            UiValidators.whitespace,
                        ]),
                    ],
                    _a));
            case DeploymentAuthenticationType.basicAuth:
                return this._fb.group((_b = {},
                    _b[DeploymentAuthenticationTypeControl.basicAuthUsername] = [
                        this._originalDeploymentSettings.basicAuthUsername,
                        Validators.compose([
                            Validators.required,
                            UiValidators.whitespace,
                            Validators.maxLength(UI_USERNAME_MAX_LENGTH),
                        ]),
                    ],
                    _b[DeploymentAuthenticationTypeControl.basicAuthPassword] = [
                        this._originalDeploymentSettings.basicAuthPassword,
                        Validators.compose([
                            Validators.required,
                            UiValidators.whitespace,
                            Validators.maxLength(UI_PASSWORD_MAX_LENGTH),
                        ]),
                    ],
                    _b));
            case DeploymentAuthenticationType.secure:
                return this._fb.group({});
        }
    };
    return UiNugetDeploymentSettingsComponent;
}());
export { UiNugetDeploymentSettingsComponent };
